<template>
    <svg
        :width="`${size}px`"
        :height="`${size}px`"
        class="spinner"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            class="path"
            :style="setColor"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
        />
    </svg>
</template>

<script>
export default {
    name: 'ChatSpinner',

    props: {
        size: {
            type: Number,
            default: 65,
        },

        color: {
            type: String,
            default: null,
        },
    },

    computed: {
        setColor() {
            return this.color ? `stroke: ${this.color} !important` : null;
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

$offset: 187;
$duration: 1.4s;

.spinner {
    animation: rotator $duration linear infinite;
}

@keyframes rotator {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(270deg);
    }
}

.path {
    stroke-dasharray: $offset;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation:
        dash $duration ease-in-out infinite,
        colors ($duration * 4) ease-in-out infinite;
}

@keyframes colors {
    0% {
        stroke: $primary-invert;
    }
    25% {
        stroke: $primary-invert;
    }
    50% {
        stroke: $primary-invert;
    }
    75% {
        stroke: $primary-invert;
    }
    100% {
        stroke: $primary-invert;
    }
}

@keyframes dash {
    0% {
        stroke-dashoffset: $offset;
    }
    50% {
        stroke-dashoffset: calc($offset / 4);
        transform: rotate(135deg);
    }
    100% {
        stroke-dashoffset: $offset;
        transform: rotate(450deg);
    }
}
</style>
